import get from 'lodash.get'
import { takeEvery, put, all, call } from 'redux-saga/effects'
import { get as getOne, getSuccess, getError } from './reducer'
import { getOrderByCode } from './query'
import fetchData from '../../utils'

function* watchGet({ payload: { payload, callback } }) {
  const resGet = yield call(fetchData, 'get', getOrderByCode, payload)
  const errors = get(resGet, 'errors', null)
  if (callback) {
    if (errors) {
      yield put(getError(get(errors, '[0].message', null)))
      return callback(getError(get(errors, '[0].message', null)))
    }
    const data = get(resGet, 'data', null)
    if (data) {
      yield put(getSuccess(get(data, 'getLookUpOrders', [])))
      return callback(getSuccess(get(data, 'getLookUpOrders', null)))
    }
  }
}

export const rootSagas = function* rootSagas() {
  yield all([takeEvery(getOne.type, watchGet)])
}
